module.exports = __webpack_public_path__ + "static/media/NotFound.768814f8.png";